// extracted by mini-css-extract-plugin
module.exports = {"subjectCaption":"subjectCaption_zf99m"};